<template>
<div id ="item-template">
  <li>
    <div
      :class="{bold: isFolder}"
      @click="toggle"
      @dblclick="changeType">
      {{model.name}}
      <span v-if="isFolder">[{{open ? '-' : '+'}}]</span>
    </div>
    <ul v-show="open" v-if="isFolder">
      <item class="item" v-for="model in model.children" :key="model.id" :model="model"></item>
    </ul>
  </li>
</div>
</template>

<script>


export default {
  name: 'item',
  template: '#item-template',
  props: {},
  model: {},
  open : false,
  data: function () { return { open: false } },
  computed: {
    isFolder: function () {
      return this.model.children &&
        this.model.children.length
    }
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    changeType: function () {
      if (!this.isFolder) {
        Vue.set(this.model, 'children', [])
        this.open = true
      }
    },
    addChild: function () {
      this.model.children.push({
        name: 'new stuff'
      })
    }
  },
  created: function() {   console.log('Item.vue', 'created'); },
  destroyed: function() { console.log('Item.vue', 'destroyed'); },
  mounted: function() { console.log('Item.vue', 'mounted'); }
}


// </script>
